(function () {
  /* SVG của app vẽ vòng tròn bằng <path>, không phải <circle>,
     nên CSS không chạm tới được — phải xoá bằng JS. */
  function fixClose(root) {
    var svg = root.querySelector('.modal-close-btn, .modalCloseButtonStyle');
    if (!svg || svg.dataset.bbDone) return;
    svg.dataset.bbDone = '1';

    var paths = svg.querySelectorAll('path');
    if (paths.length > 1) paths[paths.length - 1].remove();

    svg.querySelectorAll('path').forEach(function (p) {
      p.setAttribute('fill', '#000');
    });
  }

  /* Bọc select quốc gia trong một span để gắn chevron đúng vị trí.
     Selector CSS không bám được vì cấu trúc DOM của app không ổn định. */
  function wrapCountry(root) {
    var sel = root.querySelector('.restock-alerts-sms-channel-form select');
    if (!sel || sel.dataset.bbWrapped) return;
    sel.dataset.bbWrapped = '1';

    var wrap = document.createElement('span');
    wrap.className = 'bb-nm-country';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
  }

  function scan() {
    var dlg = document.querySelector('.nm-top-layer-dialog');
    if (!dlg) return;
    fixClose(dlg);
    wrapCountry(dlg);
  }

  /* Chỉ theo dõi con trực tiếp của body — modal được chèn ở đó,
     không quét cả cây DOM cho nhẹ. */
  new MutationObserver(scan).observe(document.body, { childList: true });

  scan();
})();
